// React
import { Col, Row } from 'reactstrap';
import React, { useCallback, useEffect, useState } from 'react';

// Containers Injections
import {
  CardList,
  notifyError,
  notifySuccess,
} from '../../../../containers/componentsInjection';

// Components
import { ModalUploadFiles } from './components/ModalUploadFiles';

// Utils
import * as url from '../../../../../../helpers/url_helper';
import { formatBytes } from '../../../../utils/fileFormatting';
import { useLoading } from '../../../../../../hook/useLoading';
import { APIClient } from '../../../../../../helpers/api_helper';

export const CardUploadFiles = ({ credential }) => {
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  function toggle() {
    setIsOpen(!isOpen);
  }

  const api = new APIClient();
  const { toggleLoading, setLoading } = useLoading();

  const getProviderFiles = useCallback(async (id) => {
    const files = await api.get(`/register/provider/file/${id}`);

    if (files) {
      setData(files);
    }
  }, []);

  function redirectToFileView(url) {
    window.open(url, '_blank');
  }

  const handleDelete = async (hash) => {
    toggleLoading();
    await api
      .delete(`/register/provider/file/${hash}`)
      .then((response) => {
        notifySuccess(response.message);
      })
      .catch((error) => {
        notifyError('Erro ao deletar arquivo!');
      })
      .finally(() => {
        setLoading(false);
      });

    getProviderFiles(credential.id);
  };

  function handleAcceptedFiles(files) {
    const updatedFiles = files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
  }

  function removeFile(index) {
    setSelectedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  }

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Arquivo</span>,
      sortable: true,
      width: '30%',
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item" title="Remove">
              {cell.filename}
            </li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Enviado por</span>,
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Data</span>,
      selector: (row) => row.created_at,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Tamanho</span>,
      selector: (row) => row.size,
      sortable: true,
    },
  ];

  const handleSubmit = () => {
    toggleLoading();
    const formData = new FormData();

    selectedFiles.forEach((file) => {
      formData.append('files[]', file);
    });
    formData.append('provider_id', credential.id);

    api
      .create(url.BASE + 'register/provider/file', formData)
      .then((response) => {
        if (response.status === 200) {
          notifySuccess('Arquivos enviados com sucesso');
          toggle();
          setSelectedFiles([]);
          getProviderFiles(credential.id);
        } else {
          notifyError('Erro ao enviar arquivos');
        }
      })
      .catch((error) => {
        notifyError('Erro ao enviar arquivos: ' + error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (credential) {
      getProviderFiles(credential?.id);
    }
  }, [credential]);

  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -24,
          }}
        >
          <CardList
            isCard
            perPage={10}
            columns={columns}
            keySearch={'file_name'}
            titleButton="Anexar arquivo"
            data={data ? data : []}
            title={'Arquivos Anexados'}
            handleButton={toggle}
            pagination
            persistTableHead
            paginationServer
            isSearch={false}
            isSearchRemote={false}
            actions={[
              {
                id: 1,
                name: 'view',
                label: 'Visualizar',
                onPress: (cellProps) => redirectToFileView(cellProps.view_url),
                icon: 'las la-file',
                classNameColorIcon: 'primary',
              },
              // {
              //   id: 2,
              //   name: 'download',
              //   label: 'Baixar',
              //   onPress: (cellProps) => handleDownload(cellProps.download_url),
              //   icon: 'las la-download',
              //   classNameColorIcon: 'primary',
              // },
            ]}
            handleDelete={(cellProps) => handleDelete(cellProps.id)}
          />
        </Col>
      </Row>

      <ModalUploadFiles
        toggle={toggle}
        isOpen={isOpen}
        removeFile={removeFile}
        handleSubmit={handleSubmit}
        selectedFiles={selectedFiles}
        handleAcceptedFiles={handleAcceptedFiles}
      />
    </React.Fragment>
  );
};
